module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Report"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabledUnlessNew
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "radioCarbonReport"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Lab")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.laboratoryId),
      expression: "radioCarbonReport.laboratoryId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.radioCarbonReport, "laboratoryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.labList), function(lab) {
    return _c('option', {
      domProps: {
        "value": lab.laboratoryId
      }
    }, [_vm._v("\n                                    " + _vm._s(lab.name + ' (' + lab.labCode + ')') + "\n                                ")])
  })], 2)]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Certainty of Anthropogenic Origin")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.anthropogenicCertaintyId),
      expression: "radioCarbonReport.anthropogenicCertaintyId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.radioCarbonReport, "anthropogenicCertaintyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.anthropogenicCertaintyList), function(anthroType) {
    return _c('option', {
      domProps: {
        "value": anthroType.anthropogenicCertaintyId
      }
    }, [_vm._v("\n                                    " + _vm._s(anthroType.description) + "\n                                ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Lab Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.laboratoryRefNumber),
      expression: "radioCarbonReport.laboratoryRefNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.radioCarbonReport.laboratoryRefNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.radioCarbonReport, "laboratoryRefNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Certainty of Human Event Association")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.humanEventCertaintyId),
      expression: "radioCarbonReport.humanEventCertaintyId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.radioCarbonReport, "humanEventCertaintyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.humanEventCertaintyList), function(eventType) {
    return _c('option', {
      domProps: {
        "value": eventType.humanEventCertaintyId
      }
    }, [_vm._v("\n                                    " + _vm._s(eventType.description) + "\n                                ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Open/Closed Site")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.isOpen),
      expression: "radioCarbonReport.isOpen"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.radioCarbonReport, "isOpen", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Closed")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Dating Method")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.datingMethodId),
      expression: "radioCarbonReport.datingMethodId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.radioCarbonReport, "datingMethodId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.datingMethodList), function(datingMethod) {
    return _c('option', {
      domProps: {
        "value": datingMethod.datingMethodId
      }
    }, [_vm._v("\n                                    " + _vm._s(datingMethod.description) + "\n                                ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Surface/Subsurface Feature")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.isSurface),
      expression: "radioCarbonReport.isSurface"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.radioCarbonReport, "isSurface", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Surface")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Subsurface")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Measured Age")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.measuredAge),
      expression: "radioCarbonReport.measuredAge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1"
    },
    domProps: {
      "value": (_vm.radioCarbonReport.measuredAge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.radioCarbonReport, "measuredAge", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Sample Material")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.radioCarbonSampleTypeId),
      expression: "radioCarbonReport.radioCarbonSampleTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.radioCarbonReport, "radioCarbonSampleTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Select a Value")]), _vm._v(" "), _vm._l((_vm.radioCarbonSampleTypeList), function(sampleType) {
    return _c('option', {
      domProps: {
        "value": sampleType.radioCarbonSampleTypeId
      }
    }, [_vm._v("\n                                    " + _vm._s(sampleType.description) + "\n                                ")])
  })], 2)]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Conventional Age (mean)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.conventionalDateMean),
      expression: "radioCarbonReport.conventionalDateMean"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1"
    },
    domProps: {
      "value": (_vm.radioCarbonReport.conventionalDateMean)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.radioCarbonReport, "conventionalDateMean", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Sample Material Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.sampleComment),
      expression: "radioCarbonReport.sampleComment"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.radioCarbonReport.sampleComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.radioCarbonReport, "sampleComment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Conventional Age (error)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.conventionalDateError),
      expression: "radioCarbonReport.conventionalDateError"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1"
    },
    domProps: {
      "value": (_vm.radioCarbonReport.conventionalDateError)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.radioCarbonReport, "conventionalDateError", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bone Dates")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.boneDateTypeId),
      expression: "radioCarbonReport.boneDateTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.radioCarbonReport, "boneDateTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Select a Value")]), _vm._v(" "), _vm._l((_vm.boneDateTypeList), function(boneType) {
    return _c('option', {
      domProps: {
        "value": boneType.boneDateTypeId
      }
    }, [_vm._v("\n                                    " + _vm._s(boneType.description) + "\n                                ")])
  })], 2)]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("13C/12C")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioCarbonReport.carbon1312),
      expression: "radioCarbonReport.carbon1312"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.radioCarbonReport.carbon1312)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.radioCarbonReport, "carbon1312", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.formDisabledUnlessNew) ? _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveForm()
      }
    }
  }, [_vm._v("Save " + _vm._s(_vm.isNew ? 'and Submit ' : '') + "Report")])]) : _vm._e()])])]), _vm._v(" "), (!_vm.fromProductionSite) ? _c('tab', {
    attrs: {
      "header": "Workflow",
      "disabled": _vm.isNew
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('workflow', {
    ref: "workflow",
    attrs: {
      "workflowId": _vm.radioCarbonReportWorkflowId,
      "parentId": _vm.radioCarbonReportId
    }
  })], 1)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3d3b5f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RadioCarbonReport.vue
// module id = 993
// module chunks = 1